module.exports = __webpack_public_path__ + "static/media/start-trial.17f3eaa4.svg";